import React from 'react';
import indexProjects2 from 'assets/images/projects/index-projects2.jpg';
import { LandingContent } from 'components/LandingContent';

const EmptyPage = ({ showProjectModal }) => {

  const landingContent = () => (
    <>
      From weddings to events to managing your business and more, you can plan it all on Aisle Planner.
      Need some inspiration to help get you started? We've got you covered. Click
      {' '}<a
        target="_blank"
        rel="noreferrer"
        href="https://help.aisleplanner.com/en/articles/2739612-what-can-i-plan-on-aisle-planner"
      >here</a> for more ideas.
    </>
  );

    return (
      <LandingContent
        action={showProjectModal}
        title="Let's make things happen!"
        description={landingContent()}
        actionButtonTitle="Add a new project"
        heroImage={indexProjects2}
      />
    );
};

export default EmptyPage;
